var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('btn',{staticClass:"flex items-center",attrs:{"disabled":_vm.disabled,"size":_vm.size,"to":_vm.disabled ? null : _vm.to}},[_c('icon',{staticClass:"text-current",attrs:{"icon":_vm.directionIcon,"size":_vm.IconSize.MD}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }